import { AbstractControl } from '@angular/forms';

export class PasswordValidation {
  static MatchPassword(ac: AbstractControl) {
    return (ac.get('password').value !== ac.get('confirm-password').value) ?
      ac.get('confirm-password').setErrors({ MatchPassword: true }) : null;
  }
}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/password-validation.ts